import { observer } from "mobx-react-lite";
import Icon from "@mdi/react";
import { mdiPlus, mdiSwapVertical } from "@mdi/js";
import { Button, Chip } from "@heroui/react";
import { feedbackSettingsStore } from "@/stores/FeedbackSettingsStore";
import SortableSettingsList from "./SortableSettingsList";

const TopicsTab: React.FC = observer(() => {
  const {
    displayTopics,
    topics,
    isLoading,
    topicOrderMode,
    isTopicOrderDirty,
    isTopicsOrderSaving,
  } = feedbackSettingsStore;

  if (isLoading) {
    return <div className="fbs-tab__loading">Загрузка...</div>;
  }

  return (
    <div className="fbs-tab" data-testid="feedback-settings-topics-tab">
      <div className="fbs-tab__header">
        <div>
          <h2 className="fbs-tab__title">Темы обращений</h2>
          <p className="fbs-tab__desc">
            {topicOrderMode
              ? "Перетащите пункты за ручку слева, чтобы изменить порядок. Нажмите «Сохранить», чтобы применить изменения."
              : "Темы, которые пользователь может выбрать при отправке обращения."}
          </p>
        </div>
        <div className="fbs-tab__actions">
          {topicOrderMode ? (
            <>
              <Button
                variant="ghost"
                onPress={() => feedbackSettingsStore.cancelTopicOrderMode()}
                isDisabled={isTopicsOrderSaving}
              >
                Отмена
              </Button>
              {isTopicOrderDirty && (
                <Button
                  variant="primary"
                  onPress={() => void feedbackSettingsStore.saveTopicOrder()}
                  isPending={isTopicsOrderSaving}
                >
                  Сохранить
                </Button>
              )}
            </>
          ) : (
            <>
              {topics.length >= 2 && (
                <Button
                  variant="ghost"
                  onPress={() => feedbackSettingsStore.enterTopicOrderMode()}
                >
                  <Icon path={mdiSwapVertical} size={0.8} />
                  Изменить порядок
                </Button>
              )}
              <Button
                variant="primary"
                onPress={() => feedbackSettingsStore.openTopicCreate()}
                data-testid="feedback-settings-topic-add"
              >
                <Icon path={mdiPlus} size={0.8} />
                Добавить тему
              </Button>
            </>
          )}
        </div>
      </div>

      {topics.length === 0 ? (
        <div className="fbs-tab__empty">Нет тем. Добавьте первую.</div>
      ) : (
        <SortableSettingsList
          items={displayTopics}
          orderEditMode={topicOrderMode}
          isSaving={isTopicsOrderSaving}
          onReorder={(from, to) =>
            feedbackSettingsStore.moveTopicDraft(from, to)
          }
          onEdit={(topic) => feedbackSettingsStore.openTopicEdit(topic)}
          renderContent={(topic) => (
            <div className="fbs-list__title-row">
              <span className="fbs-list__title">{topic.name}</span>
              <Chip
                size="sm"
                color={topic.is_active ? "success" : "default"}
                variant="soft"
              >
                {topic.is_active ? "Видима" : "Скрыта"}
              </Chip>
            </div>
          )}
        />
      )}
    </div>
  );
});

TopicsTab.displayName = "TopicsTab";
export default TopicsTab;
